import PropTypes from 'prop-types';
import { Component } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
export default class EnumField extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.onChange(value);
    };
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  getOptions() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    return this.props.schema.enum.map(e => {
      return {
        text: e,
        value: e
      };
    });
  }
  render() {
    return /*#__PURE__*/_jsx(UISelect, {
      options: this.getOptions(),
      defaultValue: ''
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      value: this.props.formData,
      onChange: this.onChange
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      autoFocus: this.props.autoFocus
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      disabled: this.props.disabled
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      placeholder: this.props.placeholder
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      readOnly: this.props.readOnly
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      clearable: !this.props.required,
      menuWidth: "auto"
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
EnumField.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  schema: PropTypes.shape({
    enum: PropTypes.array.isRequired
  }).isRequired,
  formData: PropTypes.string
};